import { render, staticRenderFns } from "./EquiposEstatus.vue?vue&type=template&id=a3866798"
import script from "./EquiposEstatus.vue?vue&type=script&lang=js"
export * from "./EquiposEstatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports